<template lang='pug'>
  .card.my-5: .card-body: .row
    .col-sm-6.col-12
      .text-right
        download-csv(
          class="btn btn-primary btn-sm"
          :labels="labels"
          :data="itemsCSV"
          :name="filename"
        ) CSV herunterladen
        input(
          ref="fileInput"
          type="file"
          accept=".csv"
          style="display: none"
          @change="handleFileUpload"
        )
        |   
        button.btn.btn-primary.btn-sm(type="button" @click="openFilePicker") CSV importieren



      label(for="intro") Anschreiben
      b-form-textarea(
        id="intro"
        v-model="intro"
        placeholder="Anschreiben"
        rows="3"
      )
      .row
        .col
          label.mt-3(for="rate") Stundensatz
          b-input-group(append="€")
            b-form-input(
              id="rate"
              v-model="rate"
              type="number"
              placeholder="Stundensatz"
            )
        .col
          label.mt-3(for="date") Gültig bis
          b-form-input(id="date" v-model="date" placeholder="Gültig bis")
        .col
          label.mt-3(for="perTable") Tabelen Anzahl
          b-form-input(id="perTable" v-model="perTable" placeholder="Tabelen Anzahl" type="number")
      br
      b-card.mb-3(bg-variant="light" v-for="(item, i) in items" :key="i")
        .row
          .col-8
            b-form-select.mb-3(v-model="item.type" :options="types" :id="'type_'+i")
          .col-4
            b-button.mt-1(block pill variant="outline-danger" size="sm" @click="remove(i)") Position löschen
        label(:for="'name_'+i" v-if="item.type != 'text'") Bezeichung
        b-form-input.mb-3(v-model="item.name" :id="'name_'+i" placeholder="Bezeichung" v-if="item.type != 'text'")
        label(:for="'html_'+i") Beschreibung
        b-form-textarea.mb-3(v-model="item.html" :id="'html_'+i" placeholder="Beschreibung")
        .row(v-if="item.type != 'text'")
          .col
            label(:for="'quantity_'+i") Anzahl
            b-form-input.mb-3(v-model="item.quantity" :id="'quantity_'+i" placeholder="Anzahl" type="number")
          .col(v-if="item.type == 'pos_free'")
            label(:for="'price_'+i") Preis
            b-input-group(append="€")
              b-form-input(
                :id="'price_'+i" 
                v-model="item.price"
                type="number"
                placeholder="Preis"
              )
      b-button(block variant="success" @click="add") Position hinzufügen
    .col-sm-6.col-12.offer-preview(ref="preview")
      p(v-for="i in introItems" v-html="i") 

      table.table.table-bordered(style='width: 100%; margin-top: 30px;margin-bottom: 40px;' v-for="t in tables")
        tr
          th(style='width: 60px; text-align: center;') Pos.
          th Bezeichnung
          th(style='width: 130px; text-align: center;') Einz. Preis
          th(style='width: 130px; text-align: center;') Anzahl
          th(style='width: 130px; text-align: center;') Preis
        tbody(v-for="(i, x) in tableItems(t)")
          tr(v-if="i.type === 'text'"): th(colspan="5"): span(v-html="i.html")
          tr(v-else :class="i.type")
            td(style='text-align: center;') {{pos(x, t)}}
            td
              strong {{i.name}}
              br
              small(v-html="convertBulletsToList(i.html)")
            td(style='text-align: right;') 
              span(v-if="i.type === 'pos'") {{numberToCurrency(rate)}}&nbsp;/&nbsp;h
              span(v-else-if="i.type === 'pos_free'") {{numberToCurrency(i.price )}}
              span(v-else) {{numberToCurrency(rate)}}
            td(style='text-align: right;') 
              span(v-if="i.type === 'pos'") {{numberToNumber(i.quantity)}}&nbsp;h
              span(v-else) {{numberToNumber(i.quantity)}}
            td(style='text-align: right;')
              span(v-if="i.type === 'pos'") {{numberToCurrency(rate * i.quantity)}}
              span(v-else) {{numberToCurrency(i.price * i.quantity)}}
          tr(v-if="items.indexOf(i) === items.length -1")
            td(colspan='4' style='text-align: right;')
              strong Gesamtbetrag netto
            td(style='text-align: right;')
              strong {{numberToCurrency(sum)}}
          tr(v-if="items.indexOf(i) === items.length -1")
            td(colspan='5' style='text-align: right;')
              small
                i Sämtliche genannte Preisangaben verstehen sich zzgl. der jeweils gültigen Umsatzsteuer.

      br
      p Dieses Angebot ist bis zum {{date}} gültig.
      p Für eventuelle Rückfragen stehe ich Ihnen natürlich jederzeit gerne zur Verfügung.
      p Mit freundlichen Grüßen
        br
        | Vincent Thelang
      br
      .border.p-3.bg-light
        p
          strong Hiermit bestätige ich das Angebot und beauftrage die Firma mit dem erbringen der oben genannten Leistungen.
        br
        br
        .row
          .col
            p __________________________
            p(style='margin-top: -12px;')  Ort
          .col
            p __________________________
            p(style='margin-top: -12px;') Datum
          .col-6
            p ____________________________________________________
            p(style='margin-top: -12px;') Unterschrift (Stempel)
        
</template>

<script>
import JsonCSV from 'vue-json-csv'
export default {
  props: ["data"],
  components: {downloadCsv: JsonCSV},
  data() {
    return {
      filename: "data.csv",
      perTable: 8,
      rate: 0,
      date: "",
      intro: "",
      items: [],
      types: {
        pos: "Position",
        pos_free: "Freie Position",
        text: "Freitext"
      },
      labels: {
        'pos': 'Pos.',
        'name': 'Bezeichung',
        'html': 'Beschreibung',
        'quantity': 'Anzahl',
        'price': 'Einz. Preis',
        'fullPrice': 'Preis'
      }
    }
  },
  mounted() {
    this.filename = document.getElementById("document_number").value + ".csv"
    for (const [key, value] of Object.entries(this.data)) {
      this[key] = value
    }
    document.getElementById("document_customer_id").addEventListener("change", x => {
      this.updateRateForCustomer(x.target.value)
    })
  },
  watch: {
  },
  updated() {
    document.getElementById("document_body").value = this.$refs.preview.innerHTML
    document.getElementById("document_form_data").value = JSON.stringify({
      perTable: this.perTable,
      rate: this.rate,
      date: this.date,
      intro: this.intro,
      items: this.items,
    },null,'\t')
  },
  computed: {
    itemsCSV(){
      const intl = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })
      return this.items.map( (x, i) => {
        let price = x.price
        if (x.type == 'pos') price = this.rate

        if (x.type == 'text'){
          return {
            pos: "",
            name: x.html,
            html: "",
            quantity: "",
            price: "",
            fullPrice: ""
          }
        }

        return {
          pos: this.pos(i, 0),
          name: x.name,
          html: x.html,
          quantity: x.quantity,
          price: intl.format(price),
          fullPrice: intl.format(x.quantity * price)
        }
      })
    },
    sum(){
      return this.items.map( x => {
        if (x.type === 'pos'){
          return this.rate * x.quantity
        }else if(x.type === 'pos_free'){
          return x.price * x.quantity
        }else{
          return 0
        }
      }).reduce((a, b) => a + b, 0)
    },
    tables(){
      return [...Array(this.tableCount).keys()]
    },
    tableCount(){
      return Math.ceil(this.items.length / this.perTable)
    },
    introItems(){
      return this.intro.split("\n").filter(x => x && x.length != 0)
    }
  },
  methods: {
    openFilePicker() {
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0]

      if (!file) return

      const reader = new FileReader()

      reader.onload = (e) => {
        const text = e.target.result.trim()
        this.items = text
          .split("\n")
          .map(row => row.split(";"))
          .map(row => {
            if (row[0] && row[0] != ""){
              return {
                type: "pos",
                name: row[0],
                html: "",
                quantity: parseFloat(row[1]),
                price: 1
              }
            }
          }).filter(n => n)
      }

      reader.readAsText(file)
    },
    convertBulletsToList(text) {
      // Zeilen aufteilen
      const lines = text.split(/\r?\n/);

      // Finde Zeilen, die mit einem Sternchen gefolgt von Leerzeichen beginnen
      const bulletLines = lines.filter(line => /^\s*\*\s+/.test(line));

      // Nur umwandeln, wenn mindestens zwei solcher Zeilen existieren
      if (bulletLines.length < 2) return text;

      let inList = false;
      const result = [];

      for (let line of lines) {
        if (/^\s*\*\s+/.test(line)) {
          if (!inList) {
            result.push('<ul>');
            inList = true;
          }
          // Entferne das führende Sternchen und Leerzeichen
          const item = line.replace(/^\s*\*\s+/, '');
          result.push(`  <li>${item}</li>`);
        } else {
          if (inList) {
            result.push('</ul>');
            inList = false;
          }
          result.push(line);
        }
      }

      if (inList) result.push('</ul>');

      return result.join('\n');
    },
    updateRateForCustomer(id){
      if (!id) return false
      fetch(`/customers/${id}.json`).then(x => x.json()).then(data => {
        this.rate = data.rate
      })
    },
    tableItems(x){
      return this.items.slice(this.perTable*x, this.perTable*(x+1))
    },
    pos(i, table){
      let index = 0
      return this.items.map( x => {
        if (x.type === 'text') return 0
        index ++ 
        return index
      })[i+(table*this.perTable)]
    },
    add(){
      let item = {type: "pos", name: "", html: "", quantity: 1, price: 1}
      this.items.push(item)
    },
    remove(i){
      this.items = this.items.filter((_x, x) => {
        return i != x        
      })
    },
    numberToCurrency(number){
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number)
    },
    numberToNumber(number){
      return new Intl.NumberFormat('de-DE').format(number)
    },

  }
}

</script>

<style>
.offer-preview{
  font-size: 12px;
}
.offer-preview ul {
  margin: 0px;
  padding-left: 10px;
}
</style>
